import React from 'react'

function Error() {
    return (
        <div className='error-page'>
        <h2>404- Error Page not found</h2>
        <p>Please use the search bar to find your page</p>
        </div>
    )
}

export default Error;